// extracted by mini-css-extract-plugin
export default {"segment":"BarSegment_segment__qN2Jt","hiddenText":"BarSegment_hiddenText__U5oj9"};